const AuthRoutes = {
  path: "/auth",
  component: () => import("@/layouts/blank/BlankLayout.vue"),
  meta: {
    requiresAuth: false,
  },
  children: [
    {
      name: "Login",
      path: "/auth/login",
      component: () => import("@/views/authentication/Login.vue"),
    },
  ],
}

export default AuthRoutes
